<template>
    <div id="about">
        <PageTitle :title="title" />
        <div class="subtitle">
            <h2>
                {{subtitle}}
            </h2>
        </div>
        <div class="about-content">
            <p v-html="content">

            </p>
        </div>
        <div v-if="loading">
            <Spinner size="large" message="Loading..." line-fg-color="#000" style="padding: 5rem 0;"/>
        </div>
        <div v-else-if="nodata">
            Sorry, we can't found your data, please try to access another page.
        </div>
        <div class="team" v-else>
            <div v-for="(member, index) in data" :key=index class="member">
                <img v-if="member.Image.length > 0" :src="`${URL}${member.Image[0].url}`" :alt="member.FirstName">
                <p  v-if="member.FirstName" class="name">
                    {{member.FirstName}} {{member.LastName}}
                </p>
                <p v-if="member.License" class="license">
                    License #{{member.License}}
                </p>
                <div class="contact">
                    <a v-if="member.Phone" v-bind:class="{ 'with-border' : member.Email}" class="label"  :href="`tel:+${member.Phone}`">{{member.Phone}}</a>
                    <a v-if="member.Email" class="label" :href="`mailto:${member.Email}`">Email {{member.FirstName}}</a>
                </div>
                <div v-if="member.Biography" class="content">
                    <read-more more-str="More +" less-str="Less-" :text="member.Biography" link="#" :max-chars="300"></read-more>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from "../components/PageTitle"
import Spinner from 'vue-simple-spinner'

export default {
    name: "About",
    components: {
        PageTitle,
        Spinner
    },
    data(){
        return{
            title: "About",
            loading: true,
            data: [],
            nodata: false,
            URL: 'https://api.minnesotapremierrealty.com',
            subtitle: 'Your Premier Boutique Real Estate Provider',
            content: `At Minnesota Premier Realty, our philosophy is simple: to center our focus on the wants and needs of each individual client. Our success comes from cultivating strong relationships and offering personalized service that is catered to each individual.
            <br><br>
            Founded in 2007 by Attorney and Broker Deno Howard, Minnesota Premier Realty is a boutique real estate agency that serves buyers, sellers, and investors throughout the Twin Cities area. Our dynamic team provides a broad range of expertise and years of success that allow us to shine in every facet of real estate, from first time home buyers to multi-million-dollar sellers.
            <br><br>
            Our clients are the heart of our organization and the reason we keep ticking. Being a boutique company, we go above and beyond and treat each person like family. We pride ourselves in offering professionalism, laser-focused attention to detail, unparalleled service, encouragement, and patience.
            <br><br>
            We thrive on celebrating everyone’s real estate journey – no matter how big or small. We look forward to walking along side of you, while you enjoy the road to your real estate success!`,
        }
    },
    metaInfo: {
        title: 'About | Minnesota Premier',
        meta: [{
            name: 'description', 
            content: "Minnesota Premier Properties."
        }]
    },
    mounted:function(){
        this.axios.get(`${this.URL}/teams?_sort=DisplayOrder:ASC`)
        .then((response) => {
            if(response.data.length === 0){
                this.nodata = true;
            } else {
                this.data = response.data;
                this.loading = false;
            }
        })
    },
}
</script>

<style lang="scss" scoped>
.subtitle{
    background: #2260ad;
    text-align: center;
    margin: 0;
    h2{
        margin: 0;
        padding: 1rem 0;
        color: #fff;
    }
}
.about-content{
    margin-top: 0;
    text-align: center;
    background: #eee;
    margin-bottom: 2rem;
    display:flex;
    justify-content: center;
    p{
        max-width: 900px;
        text-align: center;
        margin: 0 2rem;
        padding: 4rem 0;
    }
}
.team{
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    .member{
        padding: 2rem 4rem;
        width: 50%;
        &:nth-child(odd){
            border-right: 1px solid #ddd;
        }
    }
    img{
        margin: 1.5rem auto;
        display: block;
        width: 250px;
        height: 250px;
        object-fit: cover;
        max-width: 100%;
    }
    .name{
        margin: 1.5rem 0;
        font-size: 25.5px;
    }
    .license{
        font-size: 12.5px;
        opacity: 0.8;
    }
    .contact{
        display: flex;
        justify-content: center;
        a{
            text-decoration: none;
            color: #000;
            display: block;
            margin: 1rem 0;
            padding: 1rem 0;
            text-transform: uppercase;
            &.with-border{
                padding-right: 20px;
                border-right: 1px solid #000;
            }
            &:nth-child(2){
                padding-left: 20px;
            }
        }
    }
}
@media (max-width: 768px) { 
    .team{
        .member{
            width: 100%;
            padding: 0 2rem;
            &:nth-child(odd){
                border-right: none;
            }
        }
    }
    h2{
        font-size: 20px;
    }
}
</style>

<style lang="scss">
#readmore{
    text-decoration: none;
    color: #2260ad;
    text-transform: uppercase;
    font-family: 'Mulish', sans-serif;
    font-weight: 800;
    font-size: 13px;
    letter-spacing: 4px;
    display: block;
    margin: 2rem 0;
}
</style>